import { render, staticRenderFns } from "./product.vue?vue&type=template&id=79b74a69&scoped=true&"
var script = {}
import style0 from "./product.vue?vue&type=style&index=0&id=79b74a69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b74a69",
  null
  
)

export default component.exports